"use client";

import { useEffect, useState } from "react";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Menu } from "lucide-react";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  if (loading) {
    return <div className="flex gap-6">
        <div className="h-5 w-16 bg-muted animate-pulse rounded-md" />
        <div className="h-5 w-16 bg-muted animate-pulse rounded-md" />
        <div className="h-5 w-16 bg-muted animate-pulse rounded-md" />
        <div className="h-5 w-16 bg-muted animate-pulse rounded-md" />
        <div className="h-5 w-16 bg-muted animate-pulse rounded-md" />
      </div>;
  }
  return <>
      {}
      <NavigationMenu viewport={false} className="hidden md:flex">
        <NavigationMenuList className="gap-6">
          {menuItems.map(item => <NavigationMenuItem key={item.id}>
              <NavigationMenuLink asChild>
                <Link to={item.href || "#"} className="group relative inline-block text-foreground font-medium text-sm transition-colors duration-[var(--duration-medium)] hover:!bg-transparent focus:!bg-transparent hover:text-primary active:text-primary-dark">
                  {item.label}
                  <span className="absolute bottom-0 left-0 h-0.5 w-0 bg-primary transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] group-hover:w-full" />
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>)}
        </NavigationMenuList>
      </NavigationMenu>

      {}
      <Button variant="ghost" size="icon" className="md:hidden hover:!bg-transparent focus:!bg-transparent hover:text-primary active:text-primary-dark" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu">
        <Menu className="size-5" />
      </Button>

      {}
      {mobileMenuOpen && <div className="absolute top-full left-0 w-full bg-background border-b border-border shadow-soft md:hidden">
          <nav className="container mx-auto px-4 py-4 flex flex-col gap-3">
            {menuItems.map(item => <Link key={item.id} to={item.href || "#"} className="text-foreground font-medium text-sm py-2 hover:text-primary active:text-primary-dark transition-colors duration-[var(--duration-medium)]" onClick={() => setMobileMenuOpen(false)}>
                {item.label}
              </Link>)}
          </nav>
        </div>}
    </>;
}
export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header className={`sticky top-0 z-50 w-full bg-background/95 backdrop-blur-sm border-b border-border transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${scrolled ? "h-16 shadow-soft" : "h-[88px]"}`}>
      <div className="container mx-auto px-4 h-full flex items-center justify-between gap-6">
        {}
        <Link to="/#" className="shrink-0">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1509250/img/yes_chef_jess_logo.png" alt="Yes Chef Jess" className="h-7" />
        </Link>

        {}
        <MenuProvider menu_id="35" className="flex-1 flex justify-center">
          <HeaderMenuConsumer />
        </MenuProvider>

        {}
        <Button asChild className="shrink-0 hover:!bg-primary-hover focus:!bg-primary-hover hover:scale-105 hover:shadow-medium active:!bg-primary-active transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
          <Link to="/#contact">Book Now</Link>
        </Button>
      </div>
    </header>;
}